import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSignaturePadModule, SignaturePadComponent } from '@almothafar/angular-signature-pad';

@Component({
  selector: 'app-workorder-signature-pad',
  standalone: true,
  imports: [CommonModule, AngularSignaturePadModule],
  templateUrl: './workorder-signature-pad.component.html',
  styleUrls: ['./workorder-signature-pad.component.scss'],
})
export class WorkorderSignaturePadComponent {
  @Input() employeeHasSignature?: boolean;
  @Input() clientHasSignature?: boolean;
  @Output() employeeHasSignatureChange = new EventEmitter<boolean>();
  @Output() clientHasSignatureChange = new EventEmitter<boolean>();
  @ViewChild('signatureDiv') signatureDiv: ElementRef | undefined;
  @ViewChild('signaturePad') signaturePad: SignaturePadComponent | undefined;

  ngAfterViewInit() {
    if (this.signatureDiv && this.signaturePad) {
      this.signaturePad.clear();
      setTimeout(() => {
        this.signaturePad!.set('canvasHeight', this.signatureDiv!.nativeElement.offsetHeight);
        this.signaturePad!.set('canvasWidth', this.signatureDiv!.nativeElement.offsetWidth);
      }, 1);
    }
  }

  drawStart() {
    this.controlSignatureStep(true);
  }

  resizeSignaturePad() {
    if (this.signaturePad && this.signatureDiv) {
      this.signaturePad.set('canvasWidth', this.signatureDiv.nativeElement.offsetWidth);
      this.signaturePad.clear();
    }
  }

  clearSignature() {
    if (this.signaturePad) {
      this.signaturePad.clear();
      this.controlSignatureStep(false);
    }
  }

  controlSignatureStep(hasSignature: boolean) {
    if (typeof this.employeeHasSignature === 'boolean') {
      this.employeeHasSignatureChange.emit(hasSignature);
    }

    if (typeof this.clientHasSignature === 'boolean') {
      this.clientHasSignatureChange.emit(hasSignature);
    }
  }

  exportSignature(fileName: string) {
    if (this.signaturePad) {
      const dataURL = this.signaturePad.toDataURL('image/png');
      return this.dataURLToBlob(dataURL, fileName);
    }

    return new Blob();
  }

  private dataURLToBlob(dataURL: string, fileName: string) {
    var parts = dataURL.split(';base64,');
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    const blob = new Blob([uInt8Array], { type: contentType });

    return new File([blob], fileName, { type: 'image/png' });
  }
}
